module.exports = __webpack_public_path__ + "img/category_25.24f17db7.png";